import React from 'react';
export var ProductTexts = function ProductTexts(_ref) {
  var title = _ref.title,
      description = _ref.description,
      status = _ref.status;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: status === 'current_product' ? 'product-title product-current' : 'product-title'
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "product-description"
  }, description));
};